//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { getFileUrl } from '@/utils/common'
export default {
  name: 'VipInfoPage',
  extends: vModal,
  data () {
    return {
      inputValue: '',
      couponList: [],
      columns: [ // 欄位宣告
        { name: 'EVENT_NAME', label: '活動標題', field: 'EVENT_NAME' },
        { name: 'EVENT_DESC', label: '活動描述', field: 'EVENT_DESC' },
        { name: 'EVENT_IMG', label: '活動圖片', field: 'EVENT_IMG' },
        { name: 'S_DATE', label: '活動開始日期', field: 'S_DATE' },
        { name: 'E_DATE', label: '活動結束日期', field: 'E_DATE' },
        { name: 'CREATEDATE', label: '發布日期', field: 'CREATEDATE' },
        { name: 'MODIFYDATE', label: '修改日期', field: 'MODIFYDATE' }
      ],
      selectedItem: [],
      allowMulti: false, // true時 inputValue永遠只能是1
      msgTpls: [] // 取得site的訊息樣板
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'stock_no',
      'theme',
      'builderHost',
      'dateFormat',
      'siteConfig'
    ])
  },
  async created () {
    this.couponList = await this.getCoupleList()
    // console.log('couponList=')
    // console.log(this.couponList)
    this.msgTpls = await this.getMsqTpl()
    // console.log('msgTpls=')
    // console.log(this.msgTpls)
    // ----test sendMsg
    /*
    const item = {
      eventNo: 1156,
      pluCode: '501',
      rulSeq: 2946,
      sender: '000000',
      store: '000000'
    }
    await this.sendMsg(item)
    */
  },
  mounted () {
    console.log(`site config==`)
    console.log(this.siteConfig)
  },
  watch: {
    allowMulti (val) {
      if (val) this.inputValue = 1
    }
  },
  methods: {
    getFileUrl,
    moment,
    alert (message) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        this.close()
      })
    },
    // 取得有效兌換卷清單
    async getCoupleList () {
      const response = await this.fetch('couponList', this.site)
      let couponList = response.data !== null ? response.data : []
      // 加入KEEPLIVE判斷 改掉E_DATE
      couponList.forEach(item => {
        if (item.KEEPALIVE !== null) {
          // item.KEEPALIVE
          item.E_DATE = moment().add(item.KEEPALIVE, 'm')
        }
      })
      return couponList
    },
    formatDate (str) {
      return moment(str).format(this.dateFormat)
    },
    // 檢查這個row是否有被選取
    isRowSelected (row) {
      let isSelected = false
      this.selectedItem.forEach(item => {
        if (item.RUL_SEQ === row.RUL_SEQ) isSelected = true
      })
      return isSelected
    },
    addRow (row) {
      this.selectedItem.push(row)
    },
    removeRow (row) {
      const result = []
      this.selectedItem.forEach(item => {
        if (item.RUL_SEQ !== row.RUL_SEQ) result.push(item)
      })
      this.selectedItem = result
    },
    clickItem (row) {
      if (this.allowMulti) {
        if (this.isRowSelected(row)) {
          this.removeRow(row)
        } else {
          this.addRow(row)
        }
      } else {
        this.selectedItem = [row]
      }
    },
    clickSave () {
      if (this.selectedItem.length === 0) {
        this.alert('請選擇兌換卷')
        return
      }
      if (this.inputValue === '') {
        this.alert('請輸入數量')
        return
      }
      this.doSave()
    },
    async doSave () {
      // 建立要儲存的資料
      const items = []
      if (this.allowMulti) {
        this.selectedItem.forEach(item => {
          items.push({
            store: this.stock_no,
            rulSeq: item.RUL_SEQ,
            eventNo: item.EVENT_NO,
            pluCode: item.PLU_CODE
          })
        })
      } else {
        const item = this.selectedItem[0]
        const data = {
          store: this.stock_no,
          rulSeq: item.RUL_SEQ,
          eventNo: item.EVENT_NO,
          pluCode: item.PLU_CODE,
          sender: this.stock_no
        }
        for (let i = 0; i < this.inputValue; i++) {
          items.push(data)
        }
      }
      // console.log('send items=')
      // console.log(items)
      // 執行儲存
      let haveError = false
      // let errorMsg = '發送失敗！！'
      for (let i = 0; i < items.length; i++) {
        const response = await this.fetch('pointGive', this.site, this.params.id_no, items[i]).catch(e => {
          console.log('give error==')
          console.log(e)
        })
        if (response === undefined || response.result !== 'OK') {
          haveError = true
        } else {
          // 成功就發送訊息
          await this.sendMsg(items[i]).catch(e => {
            console.log('send msg error')
            console.log(e)
          })
        }
      }
      if (haveError) {
        // TODO: 需改成依照錯誤訊息顯示錯誤
        // this.alert(`發送失敗！！`)
        this.alert(`點數不足無法發送！！`)
      } else {
        this.alert(`發送成功！！`)
      }
    },
    // 贈送成功後發送通知
    async getMsqTpl () {
      // 取樣板清單
      const response = await this.fetch('getMsgTemp', this.site)
      let tpls = response.data && response.data.items ? response.data.items : []
      tpls = tpls.filter(item => {
        return item.useTarget === 'receiveCoupon'
      })
      return tpls
    },
    async sendMsg (item) {
      // 取得 發送item的PC_NAME
      console.log(`send msg item plu code=${item.pluCode}`)
      console.log(item)
      const couponResponse = await this.fetch('coupon', this.site, item.pluCode)
      // 找不到coupon就跳過
      if (couponResponse.data === null) return
      // 發送
      for (let i = 0; i < this.msgTpls.length; i++) {
        const data = {
          type: '1',
          templateId: this.msgTpls[i].id,
          store: this.stock_no,
          platforms: {
            member: true,
            line: this.siteConfig.enabled.lineRealtimeNotify
          },
          customVariables: {
            'get.coupon': couponResponse.data.PC_NAME
          }
        }
        console.log('send msg data==')
        console.log(data)
        const response = await this.fetch('sendMsgByTemp', this.site, this.params.id_no, data)
        console.log('send response=')
        console.log(response)
      }
    }
  }
}
